import * as common from "appdevresources/common";
import "appdevresources/twig.jquery";

$(async function () {
    const twig = $.twig();

    if ($("#messageCountDiv").length) {
        let msgHtml = $("#messageCountDiv").html();
        msgHtml = msgHtml.replace("w-100", "").replace("message-text-header", "")
            .replace("new-mail-icon", "green-mail-icon");
        let noteHtml = $("#origNoteCountDiv").html();
        noteHtml = noteHtml.replace("w-100", "").replace("note-text-header", "");
        $("#navbar-links").append(`<li class="nav-item d-sm-block d-md-block d-lg-none pt-1 pb-1">${msgHtml}</li>`)
            .append(`<li id="noteCountLi" class="nav-item pt-1 pb-1 d-sm-block d-md-block d-lg-none">${noteHtml}</li>`);
        $("a", "#logout-dropdown-nav-items").each(function () {
            let href = $(this).attr("href");
            let label = $(this).attr("aria-label");
            let text = $(this).text();
            let clas = label === "Add Sticky Note" ? "nav-link addStickyNote" : "nav-link";
            $("#navbar-links").append(`<li class="nav-item d-sm-block d-md-block d-lg-none"><a class="${clas}" href="${href}" aria-label="${label}">${text}</a></li>`);
        });
    }

    $("#navbar-links a.dropdown-item, .nav-spinner-initiate").off("click.showSpinner").on("click.showSpinner", function () {
        common.loadSpinner();
    });

    $(".nav-link.dropdown-toggle").on("click", function (e) {
        $(".dropdown-menu").not($(this).next(".dropdown-menu")).slideUp().addClass("d-none");
        $(this).next(".dropdown-menu").removeClass("d-none").slideToggle();
        e.stopPropagation()
    });

    $(".name-header-text.dropdown-toggle").on("click", function (e) {
        $(".dropdown-menu").not("#logout-dropdown-nav-items").slideUp().addClass("d-none");
        $(this).parent().toggleClass("show");
        $("#logout-dropdown-nav-items").removeClass("d-none").slideToggle();
        e.stopPropagation()
    });

    $("body").on("click", function () {
        $(".dropdown-menu").slideUp().addClass("d-none");
    });

    $(window).resize(function () {
        if ($(this).width() < 992) {
            $(".dropdown-menu").addClass("d-none");
        }
    });
});

console.debug("Loaded library: navigation");
